import { render, staticRenderFns } from "./JobInformationCard.vue?vue&type=template&id=5097d651"
import script from "./JobInformationCard.vue?vue&type=script&lang=js"
export * from "./JobInformationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports